/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import { action, flow, observable } from 'mobx';
import fetch from '../fetch';
import ErrorsStore from './errorsStore';
import AppStore from './appStore';
import { isError } from './actionCreator';
import get from 'lodash/get';
//import fetch from '../fetch';

class NotificationsStore {
    @observable
    selectedDeepLink = '';

    constructor() {
        this.baseUrl = '/api/generic/push';
    }

    buildDeepLinkForNews = id => {
        return `${get(AppStore, 'app.settings.push.baseDeeplink', '')}/news/${id}`;
    };

    buildDeepLinkForVideo = id => {
        return `${get(AppStore, 'app.settings.push.baseDeeplink', '')}/media/${id}`;
    };

    buildDeepLinkForContent = id => {
        return `${get(AppStore, 'app.settings.push.baseDeeplink', '')}/contents/${id}/details`;
    };

    @action.bound
    setDeepLink(deepLink) {
        this.selectedDeepLink = deepLink;
    }

    @action.bound
    send = flow(function*({ notification, params }) {
        try {
            const res = yield fetch.post({
                url:
                    '/api/generic/push/send?' +
                    Object.entries(params)
                        .map(([key, val]) => `${key}=${val}`)
                        .join('&'),
                body: {
                    data: {
                        ...notification,
                        filters: params,
                    },
                },
            });
            if (isError(res)) {
                ErrorsStore.addError(res, 'There was a problem sending notifications');
            }
            return res;
        } catch (e) {
            ErrorsStore.addError(e, 'There was a problem sending notifications');
            console.warn(e);
            return e;
        }
    });

    @action.bound
    count = flow(function*({ params = {} } = {}) {
        try {
            const res = yield fetch.get({ url: '/api/generic/push/count', params });
            if (isError(res)) {
                ErrorsStore.addError(res, 'There was a problem counting devices');
            }
            return res;
        } catch (e) {
            ErrorsStore.addError(e, 'There was a problem counting devices');
            console.warn(e);
            return e;
        }
    });
}

export default new NotificationsStore();
